var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"12","md":_vm.hasBandeja ? 9 : 12}},[_c('div',{staticClass:"calendar-wrapper elevation-1 rounded"},[_c('full-calendar',{ref:"calRef",attrs:{"options":_vm.calendarOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }